import { FC } from "react"
import { UseFormRegister, FieldValues, FieldErrors, FieldError } from "react-hook-form"
import { FormbuilderInput } from "../formbuilder-input"

interface NumberFormProps {
    register: UseFormRegister<FieldValues>
    errors: FieldErrors<FieldValues>
}

export const NumberForm: FC<NumberFormProps> = ({ register, errors }) => {
    return (
        <>
            <FormbuilderInput
                register={register}
                label={"Минимальное значение"}
                id={"min_number"}
                error={errors['min_number'] as FieldError}
                type="text"
                required={true}
                placeholder="Введите минимальное значение"
            />
            <FormbuilderInput
                register={register}
                label={"Максимальное значение"}
                id={"max_number"}
                error={errors['max_number'] as FieldError}
                type="text"
                required={true}
                placeholder="Введите максимальное значение"
            />
        </>
    )
}